module.exports = __webpack_public_path__ + "static/img/banner-img.771750b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/banner-img.png
// module id = hEDs
// module chunks = 44